// export const API_BASE_URL = 'https://admin-master.citizen.com.pk/api/'
// export const IMG_BASE_URL = 'https://admin-master.citizen.com.pk/'
// export const API_BASE_URL = 'http://127.0.0.1:8000/api/'
// export const IMG_BASE_URL = 'http://127.0.0.1:8000/'

export const API_BASE_URL = 'https://citizen.softlogictechnologies.com/api/'
export const IMG_BASE_URL = 'https://citizen.softlogictechnologies.com/'
